import { render, staticRenderFns } from "./EditMethodDia.vue?vue&type=template&id=23ef5805&scoped=true"
import script from "./EditMethodDia.vue?vue&type=script&lang=js"
export * from "./EditMethodDia.vue?vue&type=script&lang=js"
import style0 from "./EditMethodDia.vue?vue&type=style&index=0&id=23ef5805&prod&lang=scss&scoped=true"
import style1 from "./EditMethodDia.vue?vue&type=style&index=1&id=23ef5805&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef5805",
  null
  
)

export default component.exports